import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'

/** Maps old `?view=…&id=…` URLs to TanStack path routes (one-time on load). */
export function legacyPathFromSearch(search: string): string | null {
	const params = new URLSearchParams(search)
	const view = params.get('view')?.trim()
	if (!view) return null

	const id = params.get('id')?.trim()

	switch (view) {
		case 'dashboard':
		case 'projects':
			return '/projects'
		case 'project':
			return id ? `/projects/${encodeURIComponent(id)}` : '/projects'
		case 'entry':
			return id ? `/entries/${encodeURIComponent(id)}` : '/projects'
		case 'users':
			return '/users'
		case 'settings':
			return '/settings'
		default:
			return null
	}
}

export function LegacyQueryRedirect() {
	const navigate = useNavigate()

	useEffect(() => {
		const next = legacyPathFromSearch(window.location.search)
		if (!next) return
		void navigate({ to: next, replace: true })
	}, [navigate])

	return null
}
